import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons'
import { faStar as farStar, faStarHalfStroke as farStarHalfStroke } from '@fortawesome/pro-regular-svg-icons'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'

export default ({ rating }: {rating: number}) => (
  <div className="tw-flex tw-items-center">
    <div className="tw-text-lg tw-text-background tw-mr-2">{rating}</div>
    {Array.from(Array(5).keys()).map((i: number) => {
      if (rating > (i + 0.7)) {
        return <FontAwesomeIcon key={i} icon={fasStar} className={css(styles.star)} color={constants.colors.orange} />
      }
      if (rating > (i + 0.2)) {
        return (
          <FontAwesomeIcon
            key={i}
            icon={farStarHalfStroke}
            className={css(styles.star)}
            color={constants.colors.orange}
          />
        )
      }
      return <FontAwesomeIcon key={i} icon={farStar} className={css(styles.star)} color={constants.colors.orange} />
    })}
  </div>
)
const styles = StyleSheet.create({
  star: {
    fontSize: 16,
    marginRight: 1,
  },
})
